import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type { VocabularyTerm } from '../types/vocabulary.types';

export const vocabularyApi = {
  // Unwraps { data: VocabularyTerm[] } via tenantApi.getList. Ungated GET /vocabulary (Core).
  getVocabulary: (field?: string) =>
    tenantApi.getList<VocabularyTerm>('/vocabulary', field ? { params: { field } } : undefined),
};
